module.exports = __webpack_public_path__ + "img/teisyoku.b4fe19c5.jpg";